// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yHOl","question":"styles_question__13Xdn","description":"styles_description__1TVmD"};